import React from 'react';
import { WPImage } from '@/data/wp/operations/queries/fragments/image';
import Image from 'next/image';
import Paper from '@mui/material/Paper';


interface ArticleMainImageProps {
  img?: WPImage,
}

const ArticleMainImage: React.FC<ArticleMainImageProps> = ({ img }) => {
  return (
    <Paper elevation={0} square sx={{
      background: "repeating-linear-gradient(-50deg, #ededed, #ededed 12px, #dddddd 15px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      py: {
        sm: 5.5,
        xs: 0,
      }
    }}>
      {img &&
        <Image
          src={img.mediaItemUrl}
          alt={img.altText}
          width={img.mediaDetails.width}
          height={img.mediaDetails.height}
        />
      }
    </Paper>
  )
}

export default ArticleMainImage;
